import { Link } from 'react-router-dom';
import { ClipboardList, Camera, Loader2, CheckCircle } from 'lucide-react';

interface PendingActionsProps {
  pendingOrders: number;
  itemsWithoutPhotos: number;
  videosProcessing: number;
}

interface ActionItem {
  label: string;
  count: number;
  icon: React.ElementType;
  href?: string;
}

export function PendingActions({ pendingOrders, itemsWithoutPhotos, videosProcessing }: PendingActionsProps) {
  const actions: ActionItem[] = [
    { label: 'Órdenes sin QR', count: pendingOrders, icon: ClipboardList, href: '/admin/orders' },
    { label: 'Items sin foto', count: itemsWithoutPhotos, icon: Camera, href: '/admin/items' },
    { label: 'Vídeos procesándose', count: videosProcessing, icon: Loader2 },
  ];

  const hasPending = actions.some((a) => a.count > 0);

  if (!hasPending) {
    return (
      <div className="flex flex-col items-center justify-center py-8 gap-2">
        <CheckCircle className="h-6 w-6 text-green-600" />
        <p className="text-[14px] font-light text-green-700">Todo en orden</p>
        <p className="text-[12px] font-light text-[#9d9c9c]">No hay acciones pendientes</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {actions.filter((a) => a.count > 0).map((action) => {
        const content = (
          <div className="flex items-center gap-3 rounded-sm border border-amber-200 bg-amber-50 px-4 py-3 transition-colors hover:bg-amber-100">
            <action.icon className="h-5 w-5 text-amber-600 shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-[14px] font-light text-amber-800">{action.label}</p>
            </div>
            <span className="text-[16px] font-normal text-amber-700">{action.count}</span>
          </div>
        );

        if (action.href) {
          return <Link key={action.label} to={action.href}>{content}</Link>;
        }
        return <div key={action.label}>{content}</div>;
      })}
    </div>
  );
}
